import {
  Box,
  Button,
  Card,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  Fade,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  IconButton,
  TextField,
  Typography
} from '@mui/material';
import { Close } from 'mdi-material-ui';
import { forwardRef, useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { apiService } from '../../api/axiosClient';

const Transition = forwardRef((props, ref) => <Fade ref={ref} {...props} />);

const levelTranslation = (str) => {
  switch (str) {
    case "l0": return "l1";
    case "l1": return "l2";
    default: return "l3";
  }
}

const DialogCategory = (props) => {
  const { show, setShow, level, name, setReload } = props;
  const [hidden2, setHidden2] = useState(true);
  const [hidden3, setHidden3] = useState(true);
  const defaultValues = {
    level1: name?.level1,
    level2: name?.level2,
    level3: '',
    ca_order: '0',
    ca_use: true
  }
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({ defaultValues });

  useEffect(() => {
    switch (level) {
      case "l1":
        // need to make level1 readonly
        setHidden2(false);
        setHidden3(true);
        break;
      case "l2":
        // need to make level1 and level2 readonly
        setHidden2(false);
        setHidden3(false);
        break;
      default:
        setHidden2(true);
        setHidden3(true);
        break;
    }
  }, [level])

  useEffect(() => {
      reset(defaultValues);
  },[show])

  const onSubmit = async (data, e) => {

    const params = {
      "level1": data.level1,
      "level2": data.level2,
      "level3": data.level3,
      "ca_order": data.ca_order,
      "ca_use": data.ca_use,
      "level": levelTranslation(level)
    };

    try {
      await apiService.post('/category', params)
      toast.success('업데이트 되었습니다.')
      setReload(reload => reload + 1)
    } catch (error) {
      console.error(error)
    } finally {
      setShow(false)
    }
  }

  return (
    <Card>
      <Dialog
        fullWidth
        open={show}
        maxWidth='md'
        scroll='body'
        onClose={() => setShow(false)}
        TransitionComponent={Transition}
        onBackdropClick={() => setShow(false)}
      >
        <form onSubmit={handleSubmit(onSubmit)} id="categoryform">
          <DialogContent sx={{ pb: 3, px: { xs: 8, sm: 15 }, pt: { xs: 4, sm: 8 }, position: 'relative' }}>
            <IconButton
              size='small'
              onClick={() => setShow(false)}
              sx={{ position: 'absolute', right: '1rem', top: '1rem' }}
            >
              <Close />
            </IconButton>
            <Box sx={{ mb: 4, textAlign: 'center' }}>
              <Typography variant='h5' sx={{ mb: 3, lineHeight: '2rem' }}>
                카테고리 추가
              </Typography>
            </Box>

            <Grid container spacing={6}>
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <Controller
                    name='level1'
                    control={control}
                    rules={{ required: true }}
                    defaultValue=""
                    render={({ field: { value, onChange } }) => (
                      <TextField
                        value={value}
                        label='1차 카테고리'
                        id='level1'
                        onChange={onChange}
                        placeholder='1차 카테고리 제목을 입력해주세요'
                        error={Boolean(errors.level1)}
                        aria-describedby='validation-async-level1'
                        inputProps={ (level === 'l1' || level === 'l2') ? { readOnly: true } : {}}
                      />
                    )}
                  />
                  {errors.level1 && (
                    <FormHelperText sx={{ color: 'error.main' }} id='validation-async-level1'>
                      필수
                    </FormHelperText>
                  )}
                </FormControl>
              </Grid>

              <Grid item xs={12} hidden={hidden2}>
                <FormControl fullWidth>
                  <Controller
                    name='level2'
                    control={control}
                    rules={{ required: false }}
                    defaultValue=""
                    render={({ field: { value, onChange } }) => (
                      <TextField
                        value={value}
                        label='2차 카테고리'
                        id='level2'
                        onChange={onChange}
                        placeholder='2차 카테고리 제목을 입력해주세요'
                        inputProps={level === 'l2' ? { readOnly: true } : {}}
                      />
                    )}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={12} hidden={hidden3} >
                <FormControl fullWidth>
                  <Controller
                    name='level3'
                    control={control}
                    rules={{ required: false }}
                    defaultValue=""
                    render={({ field: { value, onChange } }) => (
                      <TextField
                        value={value}
                        label='3차 카테고리'
                        id='level3'
                        onChange={onChange}
                        placeholder='3차 카테고리 제목을 입력해주세요'
                      />
                    )}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={12} md={6}>
                <FormControl fullWidth>
                  <Controller
                    name='ca_order'
                    control={control}
                    rules={{ required: true }}
                    defaultValue="0"
                    render={({ field: { value, onChange } }) => (
                      <TextField
                        value={value}
                        label='우선순위'
                        id='ca_order'
                        onChange={onChange}
                        placeholder='우선순위를 입력해주세요'
                        error={Boolean(errors.title)}
                        aria-describedby='validation-async-ca_order'
                      />
                    )}
                  />
                  {errors.ca_order && (
                    <FormHelperText sx={{ color: 'error.main' }} id='validation-async-ca_order'>
                      필수
                    </FormHelperText>
                  )}
                </FormControl>
              </Grid>

              <Grid item xs={12} md={6}>
                <FormControl fullWidth>
                  <Controller
                    name='ca_use'
                    control={control}
                    rules={{ required: false }}
                    defaultValue=''
                    render={({ field: { value, onChange } }) => (
                      <FormControlLabel
                        label='노출여부'
                        control={
                          <Checkbox checked={value} onChange={onChange} name='controlled' />
                        }
                      />
                    )}
                  />
                </FormControl>
              </Grid>

            </Grid>
          </DialogContent>
        </form>

        <DialogActions sx={{ pb: { xs: 4, sm: 8 }, justifyContent: 'center' }}>
          <Button type="submit" form="categoryform" variant='contained'> 등록 </Button>
          <Button variant='outlined' color='secondary' onClick={() => setShow(false)}> 취소 </Button>
        </DialogActions>

      </Dialog>
    </Card>
  )
}

export default DialogCategory
